import {Currency} from 'util/currency';

export function readCurrency(data: any): Currency {
  const { is_default, ...props } = data;
  return {
    isDefault: is_default,
    ...props
  };
}